import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

const MOBILE_TABS = [
  { key: '/mobile/devices', labelKey: 'mobile.devices_title' },
  { key: '/mobile/dashboard', labelKey: 'mobile.dashboard_title' },
];

export default function MobileNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = location.pathname.startsWith('/mobile/dashboard')
    ? '/mobile/dashboard'
    : '/mobile/devices';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => navigate(key)}
      items={MOBILE_TABS.map((tab) => ({
        key: tab.key,
        label: t(tab.labelKey),
      }))}
      style={{ marginBottom: 16 }}
    />
  );
}
